import { IGetLoanQueryDto, ILoanResponse, Pagination } from '@patient-fi/fed-types';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import HttpError from '../../utilities/HttpError';
import { IQueryKey, IQueryKeyOptions } from '../../utilities/queryFnFactory';

export type ILoansResponse = Pagination<ILoanResponse>;

const useLoanLists = (
  { searchParams }: IQueryKeyOptions<IGetLoanQueryDto>,
  options?: Omit<
    UseQueryOptions<ILoansResponse, HttpError, ILoansResponse, IQueryKey<IGetLoanQueryDto>>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
): UseQueryResult<ILoansResponse, HttpError> =>
  useQuery<ILoansResponse, HttpError, ILoansResponse, IQueryKey<IGetLoanQueryDto>>(
    [
      '/loans',
      {
        searchParams,
      },
    ],
    options,
  );

export default useLoanLists;
